export enum SurveyVariableConditionSectionQuestionAnonymousScopeEnum {
  FullAnonymous = 'full_anonymous',
  AdminAnonymous = 'admin_anonymous',
  UserAnonymous = 'user_anonymous',
}

export const SurveyVariableConditionSectionQuestionAnonymousScopeEnumLabels: Record<
  SurveyVariableConditionSectionQuestionAnonymousScopeEnum,
  string
> = {
  [SurveyVariableConditionSectionQuestionAnonymousScopeEnum.FullAnonymous]: 'Nadie',
  [SurveyVariableConditionSectionQuestionAnonymousScopeEnum.AdminAnonymous]: 'Admin',
  [SurveyVariableConditionSectionQuestionAnonymousScopeEnum.UserAnonymous]: 'Sistema',
};
